import { render, staticRenderFns } from "./doubleTreeTransfer.vue?vue&type=template&id=f4421162&scoped=true"
import script from "./doubleTreeTransfer.vue?vue&type=script&lang=js"
export * from "./doubleTreeTransfer.vue?vue&type=script&lang=js"
import style0 from "./doubleTreeTransfer.vue?vue&type=style&index=0&id=f4421162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4421162",
  null
  
)

export default component.exports